export default __webpack_public_path__ + "static/media/don.png.webp";